import styled from 'styled-components';
import {
  Container as InvoicesTableContainer,
  Header as InvoicesTableHeader,
} from '../InvoicesTable/InvoicesTable.styles';
import { INVOICES_TABLE_COLUMNS } from '../../Invoices.constants';

export const Container = InvoicesTableContainer;

export const Header = InvoicesTableHeader;

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${INVOICES_TABLE_COLUMNS};
  gap: 16px;
  align-items: center;
  height: 68px;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};

  &:last-child {
    border-bottom: none;
  }
`;
